/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var rootScope = require('./root-scope.service');
var localize = require('./localize.service');
/**
 * Gets internationalized message by key.
 * @param key Message's key to search
 * @param translationObj Object used in translation (optional)
 *
 * @returns found value or key it self if message is not found
 */
function translate(key, translationObj) {
    var translation = translationObj ? translationObj : rootScope.getPageTranslation();

    return localize.translate(key, translation);
}

module.exports = translate;
